import React, {useState} from 'react';
import {createContext} from 'use-context-selector';
import initialSessionData from './initialSessionData';

const SessionContext = createContext(null);
const SessionContextProvider = (props) => {
    const [sessionData, setSessionData] = useState({...initialSessionData});
    return (
        <SessionContext.Provider value={[sessionData, setSessionData]}>
            {props.children}
        </SessionContext.Provider>
    );
}

export {SessionContext, SessionContextProvider};
